import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication.service';
import { UsersService } from '../../services/users.service';
import { Location } from '@angular/common';
import { MessagePopupComponent } from '../../modals/message-popup/message-popup.component';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
  standalone: false,
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss',
})
export class ForgotPasswordComponent implements OnInit {
  email = '';
  isError = false;
  isErrorText = 'something-went-wrong';

  constructor(
    private router: Router,
    private location: Location,
    private authenticationService: AuthenticationService,
    private usersService: UsersService,
    private modalService: BsModalService,
  ) {}

  ngOnInit() {
    const user = this.authenticationService.userValue;
    if (user) {
      this.router.navigate(['/dashboard']);
    }
    this.isError = false;
    this.isErrorText = 'something-went-wrong';
  }

  setEmail(event: any) {
    this.email = event.target.value;
  }

  goBack() {
    this.location.back();
  }

  async sendResetPassword() {
    this.isError = false;
    this.isErrorText = 'something-went-wrong';

    if (!this.authenticationService.validateEmail(this.email)) {
      this.isError = true;
      this.isErrorText = 'email-is-not-valid';
      return;
    }

    const credentials = {
      email: this.email,
    };
    this.usersService.forgotPassword(credentials).subscribe(
      async (response) => {
        console.log('response:');
        console.log(response);
        this.isError = true;
        this.isErrorText = 'reset-password-sent-to-email';

        let modal = this.modalService.show(MessagePopupComponent, {
          initialState: {
            title: 'reset-password-sent',
            text: 'reset-password-sent-text',
            buttonText: 'okay',
          },
          class: 'alert-modal modal-dialog-centered',
          backdrop: 'static',
        });
        modal.onHidden.subscribe(() => {
          this.location.back();
        });
      },
      (error) => {
        console.log('error:');
        console.log(error);
        this.isError = true;
        this.isErrorText = 'something-went-wrong';
      },
    );
  }
}
